import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './HealthAIApp'; // Import your main component

// Create the React root instance and link it to the HTML element with id="root"
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the main App component within React's StrictMode
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
